import { render } from "./PurchasingRequisition.vue?vue&type=template&id=2c2c2f38&scoped=true"
import script from "./PurchasingRequisition.vue?vue&type=script&lang=js"
export * from "./PurchasingRequisition.vue?vue&type=script&lang=js"

import "./PurchasingRequisition.vue?vue&type=style&index=0&id=2c2c2f38&scoped=true&lang=css"
import "./PurchasingRequisition.vue?vue&type=style&index=1&id=2c2c2f38&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c2c2f38"]])

export default __exports__